import {
  FeaturesSettings,
  initializeBasketHttp,
  initializeKnowledgeBaseHttp,
  initializePricingHttp,
  initializeProductCatalogueHttp,
  initializeSiteSettingsHttp,
  initializeStoreApiHttp,
  initializeSupportApiHttp,
  SfccSettings,
  SiteContext,
  SiteSettings,
} from '@gn-audio/jss-core';

import { PublicEnvironmentConfigs } from 'common/types/publicEnvironmentConfigs';

export const configurePricingApi = (sfccSettings: SfccSettings, isSFCCPricingOn: boolean) => {
  initializePricingHttp({
    baseUrl: sfccSettings.shopApiBaseUrl ?? '',
    marketLocale: sfccSettings.shopApiLocale ?? '',
    isSFCCPricingOn: isSFCCPricingOn,
    shopApiClientId: sfccSettings.shopApiClientId ?? '',
  });
};

export const initializeHttpClients = (
  envConfig: PublicEnvironmentConfigs,
  siteContext: SiteContext
) => {
  const {
    siteSettingsApiBaseUrl,
    productCatalogueBaseUrl,
    productCatalogueApiKey,
    storeSitecoreApiHost,
    knowledgebaseApiBaseUrl,
    supportApiBaseUrl,
  } = envConfig || {};

  if (siteSettingsApiBaseUrl) {
    initializeSiteSettingsHttp({
      siteContext,
      baseUrl: siteSettingsApiBaseUrl,
    });
  }

  if (productCatalogueBaseUrl) {
    initializeProductCatalogueHttp({
      baseUrl: productCatalogueBaseUrl,
      apiKey: productCatalogueApiKey,
    });
  }

  if (storeSitecoreApiHost) {
    initializeStoreApiHttp({
      baseUrl: storeSitecoreApiHost,
    });
  }

  if (knowledgebaseApiBaseUrl) {
    initializeKnowledgeBaseHttp({
      baseUrl: knowledgebaseApiBaseUrl,
    });
  }

  if (supportApiBaseUrl) {
    initializeSupportApiHttp({
      baseUrl: supportApiBaseUrl,
    });
  }
};

export const bootstrapClientComponents = async (
  siteSettings: SiteSettings,
  features: FeaturesSettings
) => {
  if (siteSettings.sfcc) {
    await initializeBasketHttp(siteSettings.sfcc);
    configurePricingApi(siteSettings.sfcc, features.SfccPrice ?? false);
  }
};
